import {
    FETCH_ALL_DOCTOR_SUCCESS,
    EDIT_DOCTOR,
    UPDATE_DOCTOR_SUCCESS,
    CREATE_DOCTOR_SUCCESS,
    DELETE_DOCTOR_SUCCESS,
    SET_DOCTOR,
    INIT_DOCTOR,
    SET_ROLE,
    SET_DOCTOR_MULTI,
    DOCTOR_POPUP_STATUS_CHANGE,
    DOCTOR_SMS_RESULT,
    FETCH_ALL_DOCTOR_NAMES_SUCCESS,
    COPY_DOCTOR_TO_GEN2_STATUS,
    COPY_DOCTOR_TO_GEN2_STATUS_CLEAR,
    CREATE_DOCTOR_ONBOARD_URL,
    COPY_DOCTOR_ONBOARD_URL,
    CLEAR_DOCTOR_ONBOARD_URL,
    FILTER_DOCTORS_SUCCESS,
    UPDATE_DOCTOR_STATUS_SUCCESS,
} from "constants/doctors.constants";

const INIT_STATE = {
    doctors: [],
    doctor_roles: [],
    doctor: {
        id: 0,
        first_name: '',
        last_name: '',
        email: '',
        gender: 0,
        dob: '',
        address: '',
        title: '',
        specialty_id: '',
        phone: '',
        country_id: null,
        country: {},
        specialty: {},
        languages: [],
        photo_signature: null,
        photo_profile: null,
        photo_nic: null,
        photo_medical_licence: null,
        photo_signature_file: null,
        photo_profile_file: null,
        photo_nic_file: null,
        photo_medical_licence_file: null,
        img: null,
        img_name: '',
        medical_school: '',
        qualification: '',
        fee: '',
        reg_no: '',
        bank_acc_name: '',
        bank_accont_no: '',
        bank_name: '',
        branch: '',
        package_id: 0,
        selected_langs: '',
        is_on_demand: 0,
        registration_body: '',
        nic: '',
        practice_location: '',
        consultation_duration: 5,
        pre_booking_text: '',
        is_insurance_policy: 0,
        medical_licence_exp: '',
        comment: '',
        status: 0,
        ratio: 4 / 3,
        smsState:false,
        availabilities: {},
        average_wait_time: 0,
        photo_seal: null,
    },
    view_popup_open: false,
    View_popup_data: {},
    is_doctor_names_fetched: false,
    doctor_names: [],
    // exclude_doctors_DR:[],
    copy_to_gn2_doctor: {
        open: false,
        status: '',
        message: '',
    },
    doctor_onboard_url_generate: {
        url: '',
        copied:false,
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case SET_ROLE: {
            let c = Object.assign({}, state.doctor);
            let s = Boolean(action.value)

            var str = "";
            if (c.role_ids !== undefined) {
                str = c.role_ids;
            }

            if (s) {
                if (str === "") {
                    str = "" + action.key;
                } else {
                    str = str + "," + action.key;
                }
            } else {
                str = c.role_ids.replace(new RegExp(action.key + ',?'), '');
            }
            c.role_ids = str
            return {
                ...state,
                doctor: c
            }
        }

        case SET_DOCTOR_MULTI: {
            let c = Object.assign({}, state.doctor);
            for (var i in action.value) {
                c[i] = action.value[i]
            }
            return {
                ...state,
                doctor: c
            }
        }

        //set doctor
        case SET_DOCTOR: {
            let c = Object.assign({}, state.doctor);
            c[action.key] = action.value
            return {
                ...state,
                doctor: c
            }
        }

        case INIT_DOCTOR: {
            return {
                ...state,
                doctor: action.payload
            }
        }
        case FETCH_ALL_DOCTOR_SUCCESS: {
            return {
                ...state,
                doctors: action.payload.data,
                pagination: action.payload.paginate,
                doctor: INIT_STATE.doctor
            }
        }

        case UPDATE_DOCTOR_SUCCESS: {
            let foundIndex = state.doctors.findIndex(x => x.id === action.payload.data.id);
            let all = Object.assign([], state.doctors);
            let o = action.payload.data
            all[foundIndex] = o
            return {
                ...state,
                doctors: all,
                doctor: o,
            }
        }

        case CREATE_DOCTOR_SUCCESS: {
            let all = Object.assign([], state.doctors);
            all.push(action.payload.data)
            return {
                ...state,
                doctors: all,
                doctor: INIT_STATE.doctor
            }
        }

        case DELETE_DOCTOR_SUCCESS: {
            let all = Object.assign([], state.doctors);
            let newArray = all.filter(function (c) {
                return c.id !== action.payload.id
            });
            return {
                ...state,
                doctors: newArray,
            }
        }

        case EDIT_DOCTOR: {
            let u = state.doctors.find(c => c.id === action.payload)
            let o = Object.assign(INIT_STATE.doctor, u)
            return {
                ...state,
                doctor: o
            }
        }
        case DOCTOR_POPUP_STATUS_CHANGE: {
            return {
                ...state,
                view_popup_open: action.payload.status,
                View_popup_data: action.payload.data,
                doctor: getEditContent(
                    INIT_STATE.doctor,
                    state.doctors.find((c) => c.id === action.payload.data)
                ),
            }; 
        }

        case DOCTOR_SMS_RESULT: {
            
            let foundIndex = state.doctors.findIndex(x => x.id === action.payload.id);
            let all = Object.assign([], state.doctors);
            let doctor = all[foundIndex];
            let newDoctor = {...doctor, smsResult:action.payload.result}
            //console.log(newDoctor);
            all[foundIndex] = newDoctor;   

           return {
          ...state,
           doctors: all,
           doctor: newDoctor
          }
        }
        case FETCH_ALL_DOCTOR_NAMES_SUCCESS: {
            return {
                ...state,
                is_doctor_names_fetched: action.payload.isFetched,
                doctor_names: action.payload.data
            };
        }
        case COPY_DOCTOR_TO_GEN2_STATUS: {
            return {
            ...state,
            copy_to_gn2_doctor: action.payload,
            };
        }
        case COPY_DOCTOR_TO_GEN2_STATUS_CLEAR: {
            return {
            ...state,
            copy_to_gn2_doctor: INIT_STATE.copy_to_gn2_doctor,
            };
        }
        case CREATE_DOCTOR_ONBOARD_URL: {
            // generate token with url here
            var jwt = require('jsonwebtoken');
            var expire_duration = process.env.REACT_APP_DOCTOR_ONBOARDING_URL_VALID_DAYS.toString() + " days";
            let token = jwt.sign({},
                process.env.REACT_APP_DOCTOR_ONBOARDING_SECRET_KEY,
                { expiresIn: expire_duration }
              );
            var doctor_onboard_token_url = process.env.REACT_APP_DOCTOR_ONBOARDING_URL + "/?token="+ token;
            let url_generate_object = {
                url: doctor_onboard_token_url,
                copied:false,
            }
            return {
            ...state,
            doctor_onboard_url_generate: url_generate_object,
            };
        }
        case COPY_DOCTOR_ONBOARD_URL: {
            return {
            ...state,
            doctor_onboard_url_generate: {
                ...state.doctor_onboard_url_generate,
                copied: true
            },
            };
        }
        case CLEAR_DOCTOR_ONBOARD_URL: {
            return {
            ...state,
            doctor_onboard_url_generate: INIT_STATE.doctor_onboard_url_generate,
            };
        }
        case FILTER_DOCTORS_SUCCESS: {
            return {
                ...state,
                doctors: action.payload.data,
                pagination: action.payload.paginate,
            }
        }
        case UPDATE_DOCTOR_STATUS_SUCCESS: {
            let index = state.doctors.findIndex(x => x.id === action.payload.data.id);
            let doctorList = Object.assign([], state.doctors);
            doctorList[index] = action.payload.data
            
            return {
                ...state,
                doctors: doctorList
            };
        }
        default:
            return state;
    }

    function getEditContent(initobject, o) {
        initobject.id = o.id;
        initobject.first_name = o.first_name;
        initobject.last_name = o.last_name;
        initobject.email = o.email;
        initobject.gender = o.gender;
        initobject.dob = o.dob;
        initobject.address = o.address;
        initobject.title = o.title;
        initobject.phone = o.phone;
        initobject.country = o.country;
        initobject.specialty = o.specialty;
        initobject.languages = o.languages;
        initobject.photo_signature = o.photo_signature;
        initobject.photo_profile = o.photo_profile;
        initobject.photo_nic = o.photo_nic;
        initobject.photo_medical_licence = o.photo_medical_licence;
        initobject.medical_school = o.medical_school;
        initobject.qualification = o.qualification;
        initobject.fee = o.fee;
        initobject.reg_no = o.reg_no;
        initobject.bank_acc_name = o.bank_acc_name;
        initobject.bank_accont_no = o.bank_accont_no;
        initobject.bank_name = o.bank_name;
        initobject.branch = o.branch;
        initobject.package_id = o.package_id;
        initobject.selected_langs = o.selected_langs;
        initobject.is_on_demand = o.is_on_demand;
        initobject.registration_body = o.registration_body;
        initobject.nic = o.nic;
        initobject.practice_location = o.practice_location;
        initobject.consultation_duration = o.consultation_duration;
        initobject.pre_booking_text = o.pre_booking_text;
        initobject.is_insurance_policy = o.is_insurance_policy;
        initobject.medical_licence_exp = o.medical_licence_exp;
        initobject.comment = o.comment;
        initobject.status = o.status;
        initobject.availabilities = o.availabilities;
        initobject.average_wait_time = o.average_wait_time;
        initobject.photo_seal = o.photo_seal;
        initobject.max_appoinment = o.max_appoinment;
        initobject.appoinment_blocking_time = o.appoinment_blocking_time;
        initobject.is_online = o.is_online;
        return initobject;
    }
}